<template>
  <div class="vehiclesDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <div class="title" v-if="VehicleId">{{ $t.vehicles.editVehicle }}</div>
      <div class="title" v-else>{{ $t.vehicles.addVehicle }}</div>

      <van-field
        v-model="form.VIN"
        :label="$t.vehicles.vin"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.LicensePlate"
        :label="$t.vehicles.plate"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.Brand"
        :label="$t.vehicles.brand"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.Model"
        :label="$t.vehicles.model"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.VehicleType"
        :label="$t.vehicles.vehicleType"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.Color"
        :label="$t.vehicles.color"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.Length"
        :label="$t.vehicles.length"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.Width"
        :label="$t.vehicles.width"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.Height"
        :label="$t.vehicles.height"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.MaxLoad"
        :label="$t.vehicles.maxLoad"
        :placeholder="$t.meta.input"
      />

      <van-field :label="$t.vehicles.vehiclePhoto">
        <template #input>
          <van-uploader v-model="vehiclePhoto" :max-count="1" :after-read="afterRead1" />
        </template>
      </van-field>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image, Popup, Uploader } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image).use(Popup).use(Uploader);

export default {
  name: "vehiclesDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      VehicleId: "",
      form: {
        VehicleId: "",
        VIN: "",
        LicensePlate: "",
        VehiclePhoto: "",
        Brand: "",
        Model: "",
        VehicleType: "",
        Color: "",
        Length: "",
        Width: "",
        Height: "",
        MaxLoad: "",
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      vehiclePhoto: [],
    };
  },
  created() {
    const { VehicleId } = this.$route.query;
    this.VehicleId = VehicleId;
    if (this.VehicleId) {
      this.getVehiclesInfo();
    }
  },
  methods: {
    getVehiclesInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          VehicleId: this.VehicleId,
        };
        this.$api.storage
          .getVehiclesInfo(param)
          .then((res) => {
            this.applyData(res.data);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    applyData(data) {
      this.form.VehicleId = data.VehicleId;
      this.form.VIN = data.VIN;
      this.form.LicensePlate = data.LicensePlate;
      this.form.VehiclePhoto = data.VehiclePhoto;
      this.form.Brand = data.Brand;
      this.form.Model = data.Model;
      this.form.VehicleType = data.VehicleType;
      this.form.Color = data.Color;
      this.form.Length = data.Length;
      this.form.Width = data.Width;
      this.form.Height = data.Height;
      this.form.MaxLoad = data.MaxLoad;

      if (this.form.VehiclePhoto) {
        this.vehiclePhoto.push({
          url: this.imgUrlFilter(this.form.VehiclePhoto),
        });
      }
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      var request = null;
      if (this.VehicleId) {
        request = this.$api.storage.editVehicles(param);
      } else {
        request = this.$api.storage.addVehicles(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.VehiclePhoto = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.vehiclesDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .vehiclesDetail-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      font-size: 14px;
    }
  }
}
</style>
